import { useTzFormat } from '@app/core/hooks/useTzFormat';
import { LocaleRelativeTime } from '@mi-front/ui';
import { Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

/**
 * Renders fragment creation time as relative time (e.g. "2 hours ago")
 * with full date/time in the native title tooltip (station timezone).
 */
export function FragmentCardRelativeTime({
  createdAt,
  sx,
}: {
  createdAt: string;
  sx?: SxProps<Theme>;
}) {
  const formatTz = useTzFormat();

  return (
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ '&::first-letter': { textTransform: 'capitalize' }, ...sx }}
      title={formatTz(createdAt, 'LLLL (Z)')}
    >
      <LocaleRelativeTime value={createdAt} />
    </Typography>
  );
}
